export enum SupportSkillToolName {
  LaunchSupportForm = 'launch-support-form',
}
